(function () {
  'use strict';

  var GUARD_KEY = 'vk_b2b_cart_cleared_for_session';
  var NOTICE_KEY = 'vk_b2b_cart_cleared_notice';

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Private mode: the reset may run again on the next load. Clearing an
      // already-empty cart is harmless, so this degrades safely.
    }
  }

  function removeSession(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Non-fatal.
    }
  }

  function shopifyRoot() {
    var path =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return path.charAt(path.length - 1) === '/' ? path : path + '/';
  }

  function init() {
    var marker = document.querySelector('[data-vk-b2b-session]');
    if (!marker) return;

    var isB2B = marker.getAttribute('data-vk-b2b-active') === 'true';

    if (!isB2B) {
      // Logged out, normal D2C, or a wholesale applicant without an approved
      // Company/Location. Their cart must be left alone, and the guard is
      // released so a later B2B sign-in resets again.
      removeSession(GUARD_KEY);
      return;
    }

    showNoticeIfPending();

    var sessionKey = marker.getAttribute('data-vk-b2b-session-key') || 'b2b';
    if (readSession(GUARD_KEY) === sessionKey) return;

    var cartCount = Number(marker.getAttribute('data-vk-b2b-cart-count') || '0');

    if (!cartCount) {
      // Already clean — mark done without touching the Cart API.
      writeSession(GUARD_KEY, sessionKey);
      return;
    }

    clearRetailCart(sessionKey);
  }

  function clearRetailCart(sessionKey) {
    window
      .fetch(shopifyRoot() + 'cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({}),
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart clear failed.');
        return response.json();
      })
      .then(function (cart) {
        if (cart && Number(cart.item_count) !== 0) throw new Error('Cart not empty after clear.');

        writeSession(GUARD_KEY, sessionKey);
        writeSession(NOTICE_KEY, '1');
        clearStalePortalState();
        refreshCartUi();
        showNoticeIfPending();
      })
      .catch(function () {
        // Never leave the customer in a mixed-cart state silently, and never
        // set the guard, so a refresh retries.
        showResetError();
      });
  }

  // Portal drafts belong to a previous session, not this new B2B one.
  function clearStalePortalState() {
    try {
      window.localStorage.removeItem('vkB2BOrderDraft');
      window.sessionStorage.removeItem('vkB2BOrderDraft');
      window.sessionStorage.removeItem('vkB2BOrderSnapshot');
      window.sessionStorage.removeItem('vkB2BIdempotencyKey');
    } catch (error) {
      // Non-fatal.
    }
  }

  function refreshCartUi() {
    // Zero out any rendered count/badge so the stale retail number never
    // reads as belonging to the wholesale session.
    var selectors = [
      '.cart-count',
      '[data-cart-count]',
      '.header__cart-count',
      '.cart-bubble__background + .cart-bubble__text',
      '.cart-bubble__text',
    ];
    selectors.forEach(function (selector) {
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (node) {
        node.textContent = '0';
      });
    });

    Array.prototype.slice
      .call(document.querySelectorAll('cart-drawer-component, cart-items-component'))
      .forEach(function (node) {
        if (typeof node.close === 'function') node.close();
      });

    // Let the theme's own components re-render from the now-empty cart.
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  function buildNotice(message, isError) {
    var notice = document.createElement('div');
    notice.className =
      'vk-b2b-cart-notice' + (isError ? ' vk-b2b-cart-notice--error' : '');
    notice.setAttribute('role', 'status');

    var text = document.createElement('span');
    text.textContent = message;

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'vk-b2b-cart-notice__dismiss';
    dismiss.setAttribute('aria-label', 'Dismiss');
    dismiss.textContent = '×';
    dismiss.addEventListener('click', function () {
      notice.remove();
    });

    notice.appendChild(text);
    notice.appendChild(dismiss);
    document.body.appendChild(notice);
  }

  function showNoticeIfPending() {
    if (readSession(NOTICE_KEY) !== '1') return;
    removeSession(NOTICE_KEY);
    buildNotice('Your retail cart was cleared when you signed in to your wholesale account.', false);
  }

  function showResetError() {
    buildNotice(
      'We couldn’t prepare your wholesale session. Please refresh the page and try again.',
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
